module.exports = __webpack_public_path__ + "static/media/home-bg-alexa.87b0e88b.jpg";